import { all } from 'redux-saga/effects';
  import GUIDEDSELLING_AI from 'guidedselling-ai';

import configSaga from './configSaga';
import languageSaga from './languageSaga';
import navSaga from "./navSaga";

export default function* rootSaga() {
  yield all([
    ...configSaga,
    ...languageSaga,
    ...navSaga,
  ...(GUIDEDSELLING_AI.sagas || []),
  ]);
}
